const config = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL ?? 'api url not provided',
  REACT_APP_CHATWOOT_TOKEN: process.env.REACT_APP_CHATWOOT_TOKEN ?? 'token no provided',
  ENV: process.env.REACT_APP_ENV,
}

export default config
